import React from 'react';
import SvgIcon from 'material-ui/SvgIcon';

let IconVipStone = (props) => {
  props = Object.assign({viewBox: '0 0 30 30'}, props);
  return (
    <SvgIcon {...props}>
      <path className="st0" d="M29,7.6L29,7.6l-6.2-6.1H7.2L1,7.7l0,0l0,0l14.1,20.7L29,7.6L29,7.6z M22.4,2.6L27,7.2h-5h-0.4l0,0l-1.1-2.3
	l-1-2.3H22.4z M19,13.7L15,26L9.5,8.3h11L19,13.7z M11.7,2.6h6.6l2.1,4.6H9.7L11.7,2.6z M7.6,2.6h3L8.5,7.2H8.1H3l0,0L7.6,2.6z
	 M2.7,8.3h5.1h0.4l5,16.2L2.7,8.3z M16.7,24.5l4.6-15.4l0,0l0.3-0.8h0.4h5.1L16.7,24.5z"/>
    </SvgIcon>
  );
};

IconVipStone.displayName = 'IconVipStone';
IconVipStone.muiName = 'SvgIcon';

export default IconVipStone;



// WEBPACK FOOTER //
// ./src/components/Icons/IconVipStone.js